<template>
    <v-card flat>
        <h3>OFFICE LOCATION</h3>
        <address>
            3808 Union ave<br/>
            unit#2D<br/>
            Flushing, NY 11354
        </address>
        <v-divider class="ma-3"></v-divider>
        <h3>OFFICE HOUR</h3>
        <p>
            Monday - Friday<br/>
            9:00am - 6:00pm
        </p>
        <p>
            <em><b>Tax Season</b></em><br/>
            Monday - Friday<br/>
            9:00am - 7:30pm
            <br/><br/>
            Saturday<br/>
            9:00am - 6:00pm
            <br/><br/>
            Sunday<br/>
            10:00am - 4:00pm
        </p>
        <v-divider class="ma-3"></v-divider>
        <div class="contact">
            <h3>CONTACT US</h3>
            (Accounting Department)<br/>
            <a href="tel:718-445-1818">Phone: 718-445-1818</a><br/>
            <a href="tel:888-325-9889">Fax: 888-325-9889</a><br/>
            <a href="mailto:info@prudentcpa.com">Email: info@prudentcpa.com</a><br/><br/>

            (Insurance Department)<br/>
            <a href="tel:718-445-1818">Phone: 718-445-9898</a><br/>
            <a href="mailto:info@prudentbrokerage.com">Email: info@prudentbrokerage.com</a><br/><br/>
        </div>
        <v-divider></v-divider>
    </v-card>
</template>

<script>
    export default {
        name: "CompanyContact"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/CompanyContact.vue